module.exports = __webpack_public_path__ + "img/consult_info10.4f452ff4.png";